import styled from '@emotion/styled';
import Grid from '@mui/material/Grid';
import { colors } from 'theme/colors';
import { css } from '@mui/material';

interface IStyledSidebar {
  selected: boolean;
}
export const StyledSidebar = styled.div<IStyledSidebar>`
  margin-left: 10px;
  margin-top: 40px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: flex-start;
  padding: 20px;
  background: ${colors.white};
  border: 1px solid ${colors.gray100};
  box-shadow: 0 2px 4px rgba(194, 204, 243, 0.35), 0 2px 6px rgba(194, 204, 243, 0.3),
    0 4px 8px rgba(194, 204, 243, 0.2), 0 6px 10px rgba(194, 204, 243, 0.2);
  border-radius: 4px;

  & h5 {
    font-weight: bold;
    font-size: 20px;
    line-height: 28px;
    margin-bottom: 40px;
  }

  ${({ selected }: IStyledDayCell) => css`
    ${`opacity: ${selected ? 1 : 0.3}`};
  `};
`;

export const StyledSidebarDetails = styled.div`
  width: 100%;
  padding: 20px;
  background-color: ${colors.blue50};
  margin-bottom: 288px;

  & > div {
    margin-bottom: 20px;
  }
  & > div:last-child {
    margin-bottom: 0;
  }
  & > div > h6:nth-child(2) {
    font-family: NotoSansRegular, sans-serif;
  }
`;

export const StyledNavigator = styled(Grid)`
  margin-bottom: 10px;

  & > div:first-child {
    margin-top: -7px;

    button,
    button:hover,
    button:active,
    button:focus {
      background-color: ${colors.blue50};
      color: ${colors.primary600};
      box-shadow: none;
    }

    button:hover {
      opacity: 0.8;
    }
  }
  & > div:nth-child(2) {
    font-weight: bold;
    text-transform: uppercase;
    letter-spacing: 2px;
  }
  & > div:last-child {
    margin-top: -7px;

    button,
    button:hover,
    button:active,
    button:focus {
      background-color: ${colors.blue50};
      color: ${colors.primary600};
      box-shadow: none;
    }

    button:hover {
      opacity: 0.8;
    }
  }
`;

export const StyledDayWrapper = styled.div`
  display: flex;
  flex-direction: column;
  padding: 0;
  filter: drop-shadow(0px 2px 4px rgba(194, 204, 243, 0.35))
    drop-shadow(0px 2px 6px rgba(194, 204, 243, 0.3))
    drop-shadow(0px 4px 8px rgba(194, 204, 243, 0.2))
    drop-shadow(0px 6px 10px rgba(194, 204, 243, 0.2));
  border-radius: 4px;
  flex: none;
  order: 4;
  flex-grow: 1;
  background-color: ${colors.white};
`;

export const StyledDayHead = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding: 8px 12px;
  background: ${colors.blue100};
  flex: none;
  order: 0;
  align-self: stretch;
  flex-grow: 0;

  & > div:first-child {
    font-weight: bold;
  }
`;

interface IStyledDayCell {
  selected: boolean;
}

export const StyledDayCell = styled.div<IStyledDayCell>`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding: 6px 12px;
  background-color: ${colors.white};
  flex: none;
  order: 1;
  align-self: stretch;
  flex-grow: 0;

  &:hover {
    background-color: ${colors.gray50};
  }

  & > div:first-child {
    font-weight: bold;
  }

  & > div:nth-child(2) svg {
    fill: ${colors.gray200};
  }

  ${({ selected }: IStyledDayCell) => css`
    ${`background-color: ${selected ? `${colors.blue200}` : `${colors.white}`}`};

    &:hover {
      background-color: ${selected ? `${colors.blue200}` : `${colors.gray50}`};
    }

    & > div:nth-child(2) svg {
      fill: ${selected ? `${colors.blue600}` : `${colors.gray200}`};
    }
  `};
`;
